import { connect } from 'react-redux'

import { goToOrganizationUpgrade } from 'data/ui/actions'
import { isFree } from 'data/organizations/selectors'

import SelectRoleLayout from './Layout'

export default connect(
  state => ({ organizationIsFree: isFree(state) }),
  { goToOrganizationUpgrade }
)(SelectRoleLayout)
